import React, { useState } from 'react';
import filterIcon from "../../Assets/Icons/filter.png";
import leftBtuIcon from "../../Assets/Icons/back.png";
import TextInput from "../../Components/TextInput";
import searchIcon from "../../Assets/Icons/search.png";
import downArrow from "../../Assets/Icons/chevron-down.png";
import { convertGMTToLocal } from "../../Utils/Validation";
import Input from "../../Components/Input";
import DateInput from "../../Components/DateInput";
import Dropdown from "../../Components/Dropdown";
import Loader from "../../Components/Loader";
import DisbursementsApprovalsController from '../Controllers/DisbursementsApprovalsController';
import ApproveDisbursementModal from '../Components/ApproveDisbursementModal';
import { useNavigate } from 'react-router-dom';

const DisbursementApprovalsScreen = ({disbursementApproveList,disbursementApproveLoading,disbursementApproveError,onRefresh,setDisbursementApproveError,setDisbursementApproveLoading,setDisbursementApproveList}) => {
    const [showFilters, setShowFilters] = useState(false);

    const {
        disbursements,
        handleChange,
        filters,
        setFilters,
        handleSelectEmployee,
        handleSearchEmployee,
        employeeError,
        employeeList,
        employeeLoading,
        filterError,
        showModal,
        closeModal,
        handleApproveReject,
        disbursementData,
        applyFiltersApproveList,
        resetFilters,
        toggleDropdown,
        dropdownRefs,
        openDropdown,
        statusOptions,
        visiblePages,
        handlePageChange,
        approvalDisbursementList,
        currentPage,
        totalPages,
        getStatusLabel,
        getStatusStyle,
        filterOnRefresh,
        loading
    } = DisbursementsApprovalsController(disbursementApproveList,onRefresh,setDisbursementApproveError,setDisbursementApproveLoading,setDisbursementApproveList);
    console.log('approvalDisbursementList', approvalDisbursementList)

    const navigate = useNavigate();

    return (
        <div>
            <div className="flexdisplaybetween" style={{ paddingBottom: 10 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <h2 className="tab-componrnt-title">Disbursement Approvals</h2>
                    <div className="approval-count-badge">{disbursementApproveList?.length}</div>
                </div>
                <div
                    style={{
                        cursor: "pointer",
                        color: "#5A55D2",
                        fontSize: "12px",
                        textDecoration: 'underline'
                    }}
                    onClick={() => {
                        navigate("/status-list", {
                            state: {
                                title: 'Disbursement wise Reports',
                                report_key: 'key',
                                heading: 'Approved Disbursement',
                                action_type: 'approved_disbursement',
                                selectedYear: {label:"2025-26",value:"2025-26"},
                            }
                            });
                    }}
                >
                    Show Approved Disbursements
                </div>
            </div>
            <div style={styles.container}>
                <div style={styles.filtersHeader}>
                    <button style={styles.filterButton} onClick={() => setShowFilters(!showFilters)}>
                        <img src={filterIcon} alt="Filter" style={{ marginRight: '8px', width: 12 }} />
                        <span>Filters</span>
                    </button>
                    <div>
                        <img src={leftBtuIcon} style={styles.arrowBtn} alt="Prev" />
                        <img src={leftBtuIcon} style={{ ...styles.arrowBtn, transform: 'rotate(180deg)' }} alt="Next" />
                    </div>
                </div>
            </div>

            {showFilters && (
                <div className="tasksScreen-filters-container tasksScreen-open-filters">
                    <div className="tasksScreen-filters">
                        <div className="filter-field" style={{ width: '100%' }} ref={(el) => (dropdownRefs.current["clientSearch"] = el)}>
                            <label style={{ ...styles.labaleStyle, display: 'block', }}>
                                Employee Name
                            </label>
                            <TextInput
                                label="Employee Name"
                                placeholder="Search Employee"
                                value={filters.employee}
                                onChange={(e) => handleChange("employee", e.target.value)}
                                onRightClick={handleSearchEmployee}
                                right={
                                    employeeLoading ? (
                                        <Loader loading={true} color="var(--primary-loader-color)" size="small" />
                                    ) : (
                                        <img src={searchIcon} alt="Search" style={{ cursor: "pointer", height: 18, width: 18 }} />
                                    )
                                }
                                style={{ padding: "8px 10px" }}
                                errorMessage={employeeError}
                            />

                            {employeeList?.length > 0 && (
                                <ul style={styles.dropdownList}>
                                    {employeeList.map((emp, index) => (
                                        <li
                                            key={emp?.emp_id}
                                            onClick={() => handleSelectEmployee(emp)}
                                            style={{
                                                ...styles.dropdownItem,
                                                borderBottom: index !== employeeList?.length - 1 ? "1px solid #ccc" : "none",
                                            }}
                                        >
                                            {emp?.emp_name}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        <div className="filter-field">
                            <label style={{ ...styles.labaleStyle, display: "block" }}>Expense Date</label>
                            <DateInput
                                label="Expense Date"
                                value={filters.date}
                                onChange={(e) => handleChange("date", e.target.value)}
                                // max={new Date().toLocaleDateString("en-CA")}
                            // width={220}
                            /></div>
                        <Input
                            label="Amount"
                            placeholder="Enter amount"
                            value={filters.amount}
                            onChange={(e) => handleChange("amount", e.target.value)}
                            width={220}
                            inputType = 'number'
                        />
                        <Dropdown
                            ref={(el) => (dropdownRefs.current["status"] = el)}
                            isOpen={openDropdown === "status"}
                            toggleDropdown={() => toggleDropdown("status")}
                            options={statusOptions}
                            value={filters.status}
                            onChange={(val) => handleChange("status", val)}
                            label="Status"
                            width={220}
                        />
                    </div>
                    <div className="tasksScreen-filter-buttons">
                        <button className="tasksScreen-apply-button" onClick={applyFiltersApproveList}
                        style={{ cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.5 : 1 }} disabled={loading} >
                            Apply
                        </button>
                        <button className="tasksScreen-cancel-button" onClick={() => { resetFilters(); setShowFilters(false) }}>
                            Cancel
                        </button>
                        <button className="tasksScreen-reset-button" onClick={resetFilters}>
                            Reset
                        </button>
                        {filterError && <div className="list-error-msg">{filterError} </div>}
                    </div>
                </div>
            )}

            <div className="tasksScreen-task-table-wrapper">
                <table className="tasksScreen-task-table">
                    <thead>
                        <tr>
                            <th>Expense Date</th>
                            <th>Date Approved</th>
                            <th>Employee Name</th>
                            <th style={{ textAlign: 'end' }}>Amount</th>
                            <th>Approved By</th>
                            <th>Comment</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody style={{ background: '#FFFFFF' }}>
                        {approvalDisbursementList?.map((item, idx) => (
                            <tr key={idx}>
                                <td>{item?.expense_date ? convertGMTToLocal(item?.expense_date, 'dd/MM/yyyy') : '--'}</td>
                                <td>{item?.approved_date ? convertGMTToLocal(item?.approved_date, 'dd/MM/yyyy') : '--'}</td>
                                <td>{item?.emp_name || '--'}</td>
                                <td style={{ textAlign: 'end' }}>{ item?.dis_request_amt ? Number(item?.dis_request_amt).toFixed(2) : '--' }</td>
                                <td>{item?.approved_emp_name || '--'}</td>
                                <td>--</td>
                                <td>
                                    {item?.disburse_status === 2 ? (
                                        <span
                                        style={{
                                            color: "#5A55D2",
                                            textDecoration: "underline",
                                            cursor: "pointer"
                                        }}
                                        onClick={() => handleApproveReject(item)}
                                    >
                                        Approve/Reject
                                    </span>
                                    ):(
                                        <div style={{ padding: "3px 10px", borderRadius: "20px", width: 'fit-content', fontSize: 12, ...getStatusStyle(item) }}> {getStatusLabel(item?.disburse_status)}</div>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {disbursementApproveLoading && <Loader loading={disbursementApproveLoading} color={'var(--primary-loader-color)'} />}
            {disbursementApproveError && <div className="list-error-msg">{disbursementApproveError} </div>}
            {/* Pagination */}
            <div className="tasksScreen-table-footer">
                <span className="tasksScreen-pagination-info">{`${currentPage}-${totalPages} of items`}</span>
                <div className="tasksScreen-pagination">
                    <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        <img src={downArrow} alt="Previous" className="tasksScreen-arrow-left tasksScreen-icon-image" />
                    </button>
                    {visiblePages.map((page) => (
                        <button
                            key={page}
                            className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`}
                            onClick={() => handlePageChange(page)}
                        >
                            {page}
                        </button>
                    ))}
                    <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        <img src={downArrow} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image" />
                    </button>
                </div>
            </div>
            {showModal && <ApproveDisbursementModal isOpen={showModal} onClose={closeModal} editData={disbursementData} page='disApproval' onValueChange={filterOnRefresh}/>}
        </div>
    );
};

const styles = {
    container: {
        padding: "5px",
        backgroundColor: "#f8f9fa",
        border: "1px #EFF0F4 solid",
    },
    filtersHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    filterButton: {
        backgroundColor: "white",
        color: "var(--button-bg-color)",
        border: "1px var(--button-bg-color) solid",
        padding: "7px 13px",
        cursor: "pointer",
        borderRadius: "20px",
        fontSize: "12px",
        fontWeight: "400",
        fontFamily: "Roboto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    arrowBtn: {
        marginRight: "5px",
        cursor: "pointer",
        width: "28px",
        height: "28px",
    },
    dropdownList: {
        position: "absolute",
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        borderRadius: "4px",
        maxHeight: "200px",
        overflowY: "auto",
        zIndex: 1000,
        padding: 0,
        margin: 0,
        listStyleType: "none",
        width: "220px"
    },
    dropdownItem: {
        padding: "10px",
        cursor: "pointer",
        backgroundColor: "#fff",
    },
};

export default DisbursementApprovalsScreen;